<template>
  <DropdownMenuSub v-if="'items' in mergetagItem" class="MT-drop">
    <DropdownMenuSubTrigger
      textValue=""
      class="flex items-center justify-between gap-3 bg-transparent rounded-md px-2 text-sm font-medium focus:outline-none transition duration-300 cursor-default"
      :class="{
        'hover:bg-gray-400 text-gray-100 hover:text-gray-50 data-[highlighted]:bg-gray-400 data-[highlighted]:text-gray-50':
          !inverse,
        'hover:bg-[color-mix(in_srgb,var(--c-g100)_50%,var(--c-g10))] text-gray-400 hover:text-gray-600 data-[highlighted]:bg-[color-mix(in_srgb,var(--c-g100)_50%,var(--c-g10))] data-[highlighted]:text-gray-700 data-[state=open]:bg-[color-mix(in_srgb,var(--c-g100)_50%,var(--c-g10))] data-[state=open]:text-gray-700':
          inverse,
      }"
    >
      <span class="leading-8 font-inter text-xs font-medium">
        {{ mergetagItem.name }}
      </span>
      <div>
        <font-awesome-icon :icon="['fas', 'angle-right']" class="h-[10px]" />
      </div>
    </DropdownMenuSubTrigger>
    <DropdownMenuPortal>
      <DropdownMenuSubContent
        class="z-[9999] outline-none rounded-md p-1 overflow-y-auto max-h-[350px] shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),_0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)] will-change-[opacity,transform] data-[side=top]:animate-slideDownAndFade data-[side=right]:animate-slideLeftAndFade data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade"
        :class="{
          'bg-gray-600 border border-solid border-gray-400': !inverse,
          'bg-gray-10': inverse,
        }"
        :side-offset="2"
        :align-offset="-5"
      >
        <RecursiveGroup
          v-for="(item, index) in mergetagItem.items"
          :key="('items' in item ? item.name : item.value) + index"
          :mergetag-item="item"
          :search-active="searchActive"
          :inverse="inverse"
          @insert="emitInsert"
        />
      </DropdownMenuSubContent>
    </DropdownMenuPortal>
  </DropdownMenuSub>

  <DropdownMenuItem
    v-else
    textValue=""
    class="MT-drop tiptap-mt-drop-item rounded-md px-2 text-sm font-medium focus:outline-none transition duration-300 cursor-pointer"
    :class="{
      'hover:bg-gray-400 text-gray-100 hover:text-gray-50 data-[highlighted]:bg-gray-400 data-[highlighted]:text-gray-50':
        !inverse,
      'hover:bg-[color-mix(in_srgb,var(--c-g100)_50%,var(--c-g10))] text-gray-400 hover:text-gray-600 data-[highlighted]:bg-[color-mix(in_srgb,var(--c-g100)_50%,var(--c-g10))] data-[highlighted]:text-gray-700 data-[state=open]:bg-[color-mix(in_srgb,var(--c-g100)_50%,var(--c-g10))] data-[state=open]:text-gray-700':
        inverse,
    }"
    @select="emitInsert(mergetagItem as IMergeTag)"
  >
    <span class="leading-8 font-inter text-xs font-medium">
      <template v-if="searchActive && (mergetagItem as IMergeTag).parentPath">
        {{ (mergetagItem as IMergeTag).parentPath }} &gt;
        {{ (mergetagItem as IMergeTag).text }}
      </template>
      <template v-else>
        {{ (mergetagItem as IMergeTag).text }}
      </template>
    </span>
  </DropdownMenuItem>
</template>

<script setup lang="ts">
import {
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuPortal,
  DropdownMenuSubContent,
} from "reka-ui";

export type IMergeTag = {
  value: string;
  text: string;
  label: string;
  defaultValue?: string;
  parentPath?: string;
};

export type IMergeTagGroup = {
  name: string;
  items: (IMergeTag | IMergeTagGroup)[];
};

defineProps<{
  mergetagItem: IMergeTag | IMergeTagGroup;
  searchActive?: boolean;
  inverse?: boolean;
}>();

const emit = defineEmits<{
  (e: "insert", item: IMergeTag): void;
}>();

const emitInsert = (item: IMergeTag) => {
  emit("insert", item);
};
</script>
